import {structureResponse, GENERIC_ERROR_MESSAGE} from '../helpers/apiHelper';


export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

export const storeCommon = {
  actionTypes: {
    RESPONSE_STATE_SUCCESS: 'RESPONSE_STATE_SUCCESS',
    RESPONSE_STATE_FAIL: 'RESPONSE_STATE_FAIL'
  },
  defaultErrorMessage: GENERIC_ERROR_MESSAGE
}

export const payloadAction = (payload, actionType) =>{
  return {
      type: actionType,
      payload: payload
    };
}

export const dfltSuccessResponseAction = (response) => {
  return {
    type: storeCommon.actionTypes.RESPONSE_STATE_SUCCESS,
    payload: response
  };
};

export const dfltFailResponseAction = (response) => {
  structureResponse(response)
  return {
    type: storeCommon.actionTypes.RESPONSE_STATE_FAIL,
    payload: (response?.data?.error?.message || GENERIC_ERROR_MESSAGE)

  };
};

export const dfltExceptionResponseAction = (error) => {
  let message = null
  if(error?.response){
    structureResponse(error.response)
    message = error.response.data?.error?.message
  }
  return {
    type: storeCommon.actionTypes.RESPONSE_STATE_FAIL,
    payload: message || error.message || GENERIC_ERROR_MESSAGE
  };
}

export const reset2Initial = (state, iniState) => {
  return updateObject(state, iniState);
}